import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ExperiencePage } from './pages/ExperiencePage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/experience" element={<ExperiencePage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </Router>;
}